// extracted by mini-css-extract-plugin
module.exports = {"text":"Logout_text__1LIdp"};